module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/bg_coral_sea_anemone-1bcb0f8570f8a7bf0335704fb14207e2.png";